export const getDesignationOptions = (t) => [
  { value: "1", label: t("designation.chairman") },
  { value: "2", label: t("designation.director") },
  { value: "3", label: t("designation.deputy_director") },
  { value: "4", label: t("designation.manager") },
  { value: "5", label: t("designation.head_of_department") },
  { value: "6", label: t("designation.deputy_head") },
];